import { AsyncPipe, NgIf, NgTemplateOutlet } from "@angular/common";
import { AfterViewInit, ChangeDetectorRef, Component, ContentChild, Input, OnInit, TemplateRef } from "@angular/core";
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd } from "@angular/router";
import { Observable, tap } from "rxjs";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingService } from "src/app/core/services/loading/loading.service";
import { TranslateHelper } from "../../helpers/translate.helper";
import { TranslateDto } from "src/app/core/models/translate/translate.dto";

@Component({
    selector: "loading-indicator",
    templateUrl: "./loading.component.html",
    styleUrls: ["./loading.component.scss"],
    imports: [MatProgressSpinnerModule, AsyncPipe, NgIf, NgTemplateOutlet],
    standalone: true,
})
export class LoadingComponent implements OnInit, AfterViewInit {
    classDefault = "";
    loadingRoutes$: Observable<boolean>;
    loading$: Observable<boolean>;
    listTraduction: TranslateDto = {} as TranslateDto;

    @Input()
    detectRouteTransitions = false;

    @ContentChild("loading")
    customLoadingIndicator: TemplateRef<any> | null = null;

    constructor(private loadingService: LoadingService, private router: Router, readonly cd: ChangeDetectorRef) {
        this.loadingRoutes$ = this.loadingService.loadingRoutes$;
        this.loading$ = this.loadingService.loading$;
    }

    ngOnInit() {
        this.listTraduction = TranslateHelper.getTranslation("loading");
        if(!this.customLoadingIndicator){
            this.classDefault = "spinner-container"
        }
        if (this.detectRouteTransitions) {
            this.router.events.pipe(
                tap((event) => {
                    if (event instanceof RouteConfigLoadStart) {
                        this.loadingService.loadingRoutesOn();
                    } else if (event instanceof RouteConfigLoadEnd) {
                        this.loadingService.loadingRoutesOff();
                    }
                })
            ).subscribe();
        }
    }

    ngAfterViewInit(): void {
        this.cd.detectChanges();
    }
}